import userImage from "Dashboard/images/user.jpg";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { IUser } from "authentication/domain/IUser";
import { IUserGroup } from "authentication/domain/IUserGroup";
import { useEffect, useState } from "react";
import { authServices } from "authentication/services/auth.service";
import InfoTooltip from "components/Popup/InfoTooltip";
import EmployeeSelectCustom from "./EmployeeSelectCustom";
import { IEmployee } from "Dashboard/scenes/HumanResources/domain/IEmployee";

interface IUserItemProps {
  user: IUser;
  currentUser: IUser;
  employees: IEmployee[];
  updateFieldChanged: Function;
  setSelectedUser: Function;
  openDeleteUserModal: Function;
  openChangeUserPasswordModal: Function;
  openUserGroupsModal: Function;
  openUploadImageModal: Function;
  roles: IUserGroup[];
}

const UserItem = ({
  user,
  currentUser,
  employees,
  setSelectedUser,
  openDeleteUserModal,
  openChangeUserPasswordModal,
  openUploadImageModal,
  openUserGroupsModal,
  updateFieldChanged,
  roles,
}: IUserItemProps) => {
  const [img, setImg] = useState<string | null>(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [newFullName, setNewFullName] = useState(null);
  const [clear, setClear] = useState(null);

  const updateNameOrEmployee = () => {
    if (employeeId !== null) {
      updateFieldChanged(user.username, "employee", null, employeeId)()
    }
    if (newFullName !== null) {
      updateFieldChanged(user.username, "name", newFullName)();
    }
    if (clear !== null) {
      updateFieldChanged(user.username, "clear")();
    }
  };

  async function getProfilePicture() {
    try {
      const img = await authServices.getProfilePictureForSpecificUser(user.username);
      setImg(img);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    updateNameOrEmployee();
  }, [employeeId, newFullName, clear]);

  useEffect(() => {
    getProfilePicture();
  }, []);

  return (
    <div className="user-container">
      <div className="user-item item1">
        <img
          src={img ? img : userImage}
          width="100%"
          alt="img"
          onClick={() => {
            setSelectedUser(user);
            openUploadImageModal();
          }}
        />
      </div>
      <div className="user-item item2">
        <EmployeeSelectCustom
          defaultValue={user.name
            ? user.name
            : (user.employee?.name ? user.employee?.name : "")}
          employeeOptions={employees}
          placeholder="Ime i prezime korisnika"
          setEmployee={setEmployeeId}
          setNewFullName={setNewFullName}
          clearValue={setClear}
          classes="dropdownUser"
        />
      </div>
      {user.employee && (
        <InfoTooltip
          classesProp="user-item item3"
          tooltip={`Zaposleni ${user.employee.name} (${user.employee.role})`}
          pos={{ top: -175, left: 250 }}
        >
          <input
            type="text"
            className="settings-input w100 red"
            value={`${user.username}*`}
            readOnly
          />
        </InfoTooltip>
      )}
      {!user.employee && (
        <div className="user-item item3">
          <input
            type="text"
            className="settings-input w100 red"
            value={user.username}
            readOnly
          />
        </div>
      )}
      <div className="user-item item4">
        {user.username !== "admin" &&
          user.username !== currentUser.username && (
            <span
              onClick={() => {
                setSelectedUser(user);
                openDeleteUserModal();
              }}
            >
              <RemoveCircleOutlineIcon className="minus-button" />
            </span>
          )}
        <InfoTooltip
          onClick={() => {
            setSelectedUser(user);
            openUserGroupsModal();
          }}
          tooltip={`${user.userGroups.map((group, index) => (
            (index ? " " : "") + group.name
          ))}`}
          pos={{ top: -173, left: 150 }}
          classesProp="settings-input text-overflow select w80 center"
          element="span"
        >
          {user.userGroups.map((group, index) => (
            (index ? ", " : "") + group.name
          ))}
        </InfoTooltip>
      </div>
      <div className="user-item item5">
        <input
          type="password"
          style={{ cursor: "pointer" }}
          className="settings-input w100"
          value="12345678"
          readOnly
          onClick={() => {
            setSelectedUser(user);
            openChangeUserPasswordModal();
          }}
        />
      </div>
    </div>
  );
};

export default UserItem;
